import { useEffect, useCallback, useState } from 'react'

/**
 * @function
 * @description Runs before all other code if you put it first and only runs once.
 * Functions just like the react class component constructor.
 * @param {Function} props Component props.
 * @param {string} eventKey Ley on the event for the component.
 * @param {string|number|boolean} defaultValue Default value.
 * @param {boolean} isSlider Indicates that this is being used by the MUI slider component.
 * @returns {Function} returns the onChange function for the component.
 */
const useBaseComponentOperations = (props, eventKey, defaultValue, isSlider) => {
  // Component state management.
  const [value, setValue] = useState(props[eventKey] !== undefined ? props[eventKey] : defaultValue)
  // This allows a mix of a component controlled value through state and parent controlled value through props.
  useEffect(() => {
    if (props[eventKey] !== undefined) {
      setValue(props[eventKey])
    }
  }, [props[eventKey]])
  // onChange handler.
  const onChange = useCallback((event, newValue) => {
    if (!isSlider) {
      newValue = event.target[eventKey]
    }
    setValue(newValue)
    if (typeof props.onChange === 'function') {
      props.onChange(newValue)
    }
  }, [props.onChange])
  return [value, onChange, setValue]
}

export default useBaseComponentOperations